export const i18nGetLocalizedKey = (data: object, key: string) => {
  const currentLanguageCode = baseI18nGetActiveCode()
  if (!data) return null
  if ((data instanceof Object) === false) return null


  return data?.[`i18n_${key}_${currentLanguageCode}`] || null
}
